import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  getColumnKey,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { isNotNil } from '@web/utils';
import { AdminPaymentMethodCollectionItem } from '../../models/admin-payment-method-collection-item';
import { AdminPaymentMethodCollectionFilter } from '../../models/admin-payment-method-collection-filter';

@Component({
  selector: 'app-admin-payment-method-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
  ],
  templateUrl:
    './admin-payment-method-list-custom-cell-template.component.html',
  styleUrl: './admin-payment-method-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPaymentMethodListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminPaymentMethodCollectionItem, AdminPaymentMethodCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminPaymentMethodCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminPaymentMethodCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
